/**
 * Actions for Create Schema
 */
export enum createSchema {
  CREATE_SCHEMA_REQUEST = 'CREATE_SCHEMA_REQUEST'
}

/**
 * Action for Fetch Schema
 */
export enum getSchemaType {
  FETCH_SCHEMA_REQUEST = 'FETCH_SCHEMA_REQUEST'
}
